import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { AmericanStatesReducer } from './AmericanStates'
import { CountyReducer } from './County'
import { ZipCodeReducer } from './ZipCode'
import { AddressReducer } from './Address'
import { MapWaterSystemsMetricsReducer, WaterSystemsMetricsReducer } from './publicWaterSystem'
import { MapWellWaterSystemsMetricsReducer } from './wellWaterSystem'
import { WellWaterSystemsMetricsReducer, WellWaterSystemsAggregatesReducer, WellWaterSystemCoordinatesReducer, WaterSystemGeoBlocksReducer } from './wellWaterSystem'
import { WaterSystemsReducer, WellWaterSystemsReducer } from './waterSystems'
import { UtilityDetailReducer } from './utilityDetails'
import { WaterSystemCoordinatesReducer } from './publicWaterSystem'
import { PublicWaterSystemsAggregatesReducer } from './publicWaterSystem'
import { MapReducer } from './Map'
import { FormsReducer } from './forms'
import { WaterTestStripReducer } from './waterTestStrip'
import { errorMiddleware } from './middleware/errorMiddleware'
import { parameterDetailsReducer } from './parameterDetails'
import { WaterTestFormReducer } from './waterTestForm'
import { VerificationReducer } from './Verification'
import { SnackbarReducer } from './snackbar'
import { AppReducer } from './app'
import { mapMiddleware }          from './middleware/map.middleware'
import { WaterTestParamsReducer } from './waterTestParams'
import { WaterInfoReducer }     from './waterInfo'
import { WaterTestKitsReducer } from './waterTestKitRequests'
import { UrlMapReducer } from './urlMaps/urlMap.slice'
import { UserReducer } from './User'
import { WaterTestKitResultsReducer } from './waterTestKitResults'
import { PubWaterSystemReducer } from './publicWaterSystem/pubWaterSystem'
import { AppliancesReducer } from './Appliances'
import { ViolationEnforcementReducer } from './ViolationEnforcements'
import { EventMilestonesReducer } from './eventMilestones'
import { WaterQualityIndexReducer } from './waterQualityIndex'
const persistConfig = {
  key: 'root',
  storage,
}

const rootReducer = combineReducers({
  address: AddressReducer,
  americanStates: AmericanStatesReducer,
  app: AppReducer,
  appliances: AppliancesReducer,
  county: CountyReducer,
  eventMilestones: EventMilestonesReducer,
  forms: FormsReducer,
  map: MapReducer,
  mapWaterSystemMetrics: MapWaterSystemsMetricsReducer,
  mapWellWaterSystemMetrics: MapWellWaterSystemsMetricsReducer,
  parameterDetails: parameterDetailsReducer,
  snackbar : SnackbarReducer,
  utilityDetails: UtilityDetailReducer,
  urlMap: UrlMapReducer,
  user: UserReducer,
  verification: VerificationReducer,
  pubWaterSystem: PubWaterSystemReducer,
  violationEnforcements: ViolationEnforcementReducer,
  waterInfo: WaterInfoReducer,
  waterSystemAggregates: PublicWaterSystemsAggregatesReducer,
  waterSystemCoordinates: WaterSystemCoordinatesReducer,
  waterSystemGeoBlocks: WaterSystemGeoBlocksReducer,
  waterSystemMetrics: WaterSystemsMetricsReducer,
  waterSystems: WaterSystemsReducer,
  waterTestForm: WaterTestFormReducer,
  waterTestParams: WaterTestParamsReducer,
  waterTestKits: WaterTestKitsReducer,
  waterTestKitResults: WaterTestKitResultsReducer,
  waterTestStrip: WaterTestStripReducer,
  wellWaterSystemAggregates: WellWaterSystemsAggregatesReducer,
  wellWaterSystemCoordinates: WellWaterSystemCoordinatesReducer,
  wellWaterSystemMetrics: WellWaterSystemsMetricsReducer,
  wellWaterSystems: WellWaterSystemsReducer,
  waterQualityIndex: WaterQualityIndexReducer,
  zipCode: ZipCodeReducer,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,

  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST']
      }
    }).concat(errorMiddleware, mapMiddleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
